import React from "react";
import { Stage, Layer } from 'react-konva';
import BottomCloudsGroup from './BottomCloudsGroup'


export class BottomClouds extends React.Component {
  render() {
    // Stage is a div container
    // Layer is actual canvas element (so you may have several canvases in the stage)
    // And then we have canvas shapes inside athe Layer
    const sw = window.innerWidth
    //const sh = window.innerHeight
    const sh = 250
    //const halfsw = sw / 2

    const topOffset = this.props.topOffset

    const stageStyle = {
      position: 'absolute',
      top: topOffset,
      left: `0px`,
      zIndex: 10,
    }

    return (
      <Stage width={sw} height={sh} style={stageStyle}>
        <Layer>
          <BottomCloudsGroup topOffset={ this.props.topOffset }/>
        </Layer>
      </Stage>
    );
  }
}
